import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { z } from 'zod';

const responseCommonError = z.object({
  data: z.object({
    message: z.string(),
    statusCode: z.number(),
    error: z.string(),
    correlation_id: z.string(),
    timestamp: z.string(),
  }),
  status: z.number(),
});

type ResponseCommonError = z.infer<typeof responseCommonError>;
/**
 * Type predicate to narrow an unknown error to `FetchBaseQueryError`
 */
export function isFetchBaseQueryError(
  error: unknown,
): error is FetchBaseQueryError {
  return typeof error === 'object' && error != null && 'status' in error;
}

/**
 * Type predicate to narrow an unknown error to an object with a string 'message' property
 */
export function isErrorWithMessage(
  error: unknown,
): z.SafeParseReturnType<ResponseCommonError, ResponseCommonError> {
  return responseCommonError.safeParse(error);
}
